import { axios } from 'boot/axios'

export default {
  namespaced: true,
  state: {
    items: []
  },

  getters: {
    findIndex: ({ items }) => itemId => items.findIndex(({ id }) => id === itemId),
    find: ({ items }) => itemId => items.find(({ id }) => id === itemId),

    getBank: (state, { find, findIndex }) => bankId => findIndex(bankId) === -1 ? {} : find(bankId),
    getBankLabel: (state, { getBank }) => bankId => getBank(bankId).name,

    bankOptions: ({ items }) => items.map(({ id, name }) => ({ label: name, value: id }))
  },

  actions: {
    fetchBanks ({ commit, state: { items } }) {
      if (items.length === 0) {
        axios.get('banks').then(({ data }) => { commit('SET_BANKS', data) })
      }
    }
  },

  mutations: {
    SET_BANKS (state, data) { state.items = data }
  }
}
